// Models
import Model from './Model'

export default class Admin extends Model {
  get email () {
    return this.id
  }

  get schema () {
    return [
      'id',
      'name',
      'phone',
      'onboarder',
      'authorities',
      'deleted',
      'slackId',
      'photo',
      'primaryGroup',
      'groups',
      'licenses',
      'selectedLicense'
    ]
  }
}
